module.exports = __webpack_public_path__ + "img/editIcon.e193d907.svg";